import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AnalyticEvents } from '@app/enums';
import { Question } from '@app/models/recruiting/question.model';
import { AnalyticService } from '@app/services';
import { AccessLevelDisplayOptions } from '@app/types/translatables/access-level-display.options';
import {
    QuestionTypeDescriptionDisplayOptions,
    QuestionTypeDisplayOptions,
} from '@app/types/translatables/question-type-display.options';
import { JobPosting } from '@models/recruiting/job-posting.model';
import { HiringAccessLevelLabel, HiringAccessLevels } from '../../constants/hiring-access-levels.constant';
import { jobPostingType, JobQuestionTypes, jobQuestionTypes } from '../../meta/question-types';

@Component({
    selector: 'app-additional-question-dialog',
    templateUrl: './additional-question-dialog.template.html',
    styleUrls: ['./additional-question-dialog.style.scss'],
})
export class AdditionalQuestionDialogComponent implements OnInit {
    @Input() openDialog = false;
    @Input() header = 'applicant-tracker.components.additional-questions-dialog.addAQuestion';
    @Input() mode: 'edit' | 'add';
    @Input() question: Question;
    @Input() jobPosting: JobPosting;

    @Output() questionAdded = new EventEmitter<Question>();
    @Output() questionEdited = new EventEmitter<Question>();
    @Output() closeJobPostingQuestionDialog = new EventEmitter();

    selectedVisibilityType = '';

    accessLevels: HiringAccessLevelLabel[];
    accessLevelDisplay = AccessLevelDisplayOptions;
    jobQuestionTypes: JobQuestionTypes[] = jobQuestionTypes;
    jobPostingType = jobPostingType;
    questionTypeDisplay = QuestionTypeDisplayOptions;
    questionTypeDescriptionDisplay = QuestionTypeDescriptionDisplayOptions;

    constructor(private analyticsService: AnalyticService) {}

    ngOnInit(): void {
        this.accessLevels = Object.values(HiringAccessLevels).map((x) => x.label);
        this.header = `applicant-tracker.components.additional-questions-dialog.${this.mode === 'add' ? 'addAnAdditionalQuestion' : 'editAdditionalQuestion'}`;
        this.question = this.question ? this.question : new Question({ isAutoArchive: false, isRequired: false });
    }

    onAdd(form: NgForm): void {
        if (!form.valid) {
            return;
        }

        this.questionAdded.emit(this.question);
        this.analyticsService.trackEvent(this.getEvent());
        this.closeDialog();
    }

    onEdit(form: NgForm): void {
        if (form.invalid) {
            return;
        }

        this.questionEdited.emit(this.question);
        this.analyticsService.trackEvent(this.getEvent());
        this.closeJobPostingQuestionDialog.emit();
    }

    onJobQuestionType(selection: JobQuestionTypes): void {
        if (!selection) {
            return;
        }

        this.question.atsJobPostingQuestionTypeId = selection.jobPostingQuestionTypeId;
        this.question.fieldType = selection.fieldType;
    }

    compareWith(selected: JobQuestionTypes, original: number): boolean {
        return selected?.jobPostingQuestionTypeId === original;
    }

    closeDialog(): void {
        this.closeJobPostingQuestionDialog.emit();
    }

    private getEvent(): AnalyticEvents {
        if (this.mode === 'add') {
            return this.jobPosting?.isPersisted
                ? AnalyticEvents.AddAdditionalQuestionFromScratchOnExistingPosting
                : AnalyticEvents.AddAdditionalQuestionFromScratchOnNewJobPosting;
        }

        return this.jobPosting?.isPersisted
            ? AnalyticEvents.EditAdditionalQuestionOnExistingPosting
            : AnalyticEvents.EditAdditionalQuestionOnNewJobPosting;
    }
}
